export default "__VITE_ASSET__TTuWScGh__"